import React, { useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from 'uuid';

const useStyles = createUseStyles({
    wrapper: {
        alignItems: "center",
        color: "#333",
        display: "flex",
        justifyContent: "flex-start",
        padding: "0 0.5rem"
    },
    "button-wrapper--plus-minus": {
        flexBasis: "100%",
        flexGrow: 100
    },
    "@media(min-width: 480px)": {
        "button-wrapper--plus-minus": {
            flexBasis: "unset",
            flexGrow: "unset"
        }
    },
    "button--plus": {
        composes: ["btn", "btn-outline-secondary", "mx-2"],
        display: "inline-block"
    },
    "button--minus": {
        extend: "button--plus"
    },
    "button--update": {
        composes: ["btn", "btn-link", "mx-2"],
        display: "inline-block",
        padding: 0
    },
    "button--cancel": {
        extend: "button--update"
    },
    "input--custom": {
        composes: ["d-block", "mr-3", "border-0"],
        width: "3rem"
    }
})

export default function InputIncrement({
    label,
    name,
    handleCancel,
    handleSave,
    min,
    max,
    value
}){
    const [val, setVal] = useState(value);
    const id = useRef(`${name}-${uuidv4()}`);
    const styles = useStyles();

    function handle_change(e) {
        const val = Number(e.target.value);
        if(typeof val === "number") {
            setVal(val);
        }
    }

    function increment(type) {
        const value = (
            type === "plus"
                ? Number(val) + 1
                : (
                    type === "minus"
                        ? Number(val) - 1
                        : Number(val)
                )
        );
        if(value >= min && value <= max) {
            setVal(value);
        }
    }

    function handle_update(e) {
        handleSave(val);
    }

    return (
        <div 
            className={styles.wrapper}
        >
            <div className="form-inline">
                <label htmlFor={id.current} className="d-block mr-2">{label}:</label>
                <input
                    className={styles["input--custom"]}
                    id={id.current}
                    min={min}
                    max={max}
                    onChange={handle_change}
                    type="number"
                    value={val}
                />
            </div>
            <div className={styles["button-wrapper--plus-minus"]}>
                <button 
                    className={styles["button--plus"]}
                    onClick={() => increment("plus")}
                >+</button>
                <button 
                    className={styles["button--minus"]}
                    onClick={() => increment("minus")}
                >-</button>
            </div>
            <div>
                <button 
                    className={styles["button--update"]}
                    onClick={(e) => handle_update(e)}
                >Update</button>
                <button 
                    className={styles["button--cancel"]}
                    onClick={handleCancel}
                >Cancel</button>
            </div>
        </div>
    );
}

InputIncrement.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired
}

InputIncrement.defaultProps = {
    handleCancel: () => false,
    handleSave: () => false,
    label: "Label is required",
    name: "increment_input",
    min: 0,
    max: 100
}